import React, { useContext, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useHistory } from "react-router-dom";
import { empPin, showRewardsProgram } from "../../config/envConfig";
import { resource } from "../../config/config";
import Header from "../../container/header/header";

import BGImageBottomRight from "../../assets/images/signup/bg_bottom_right.svg";
import BGImageTopLeft from "../../assets/images/signup/bg_top_left.svg";
import OneOfTwo from "../../assets/images/signup/one_of_two.svg";
import TwoOfTwo from "../../assets/images/signup/two_of_two.svg";

import Button from "../../components/atoms/button";
import CustomCheckbox from "../../components/atoms/customCheckbox";
import CustomOtpInput from "../../components/atoms/customOtpInput";
import Image from "../../components/atoms/image";
import Input from "../../components/atoms/input";
import Text from "../../components/atoms/text";
import { UserContext } from "../../context/userContext";
import apiList from "../../services/apiList";
import { callApi } from "../../services/callApi";
import styles from "./empSignin.module.css";
import { useCookies } from "react-cookie";
import Util from "../../utils/util";
import { NoteIcon } from "../../utils/iconList";
import "./empSignin.css";
import ButtonWithLoading from "../../components/molecules/buttonWithLoading";
import { isTablet } from "react-device-detect";
import {
  isTab,
  sendMessageToReactNative,
  getUserInfo,
} from "../../utils/helperFunctions";
import { setLocalStorage, setSessionStorage } from "../../utils/storageUtil";

function EmpSignin() {
  const history = useHistory();
  const useUser = useContext(UserContext);
  const [cookies] = useCookies(["kioskUser"]);
  const [stage, setStage] = useState(0);
  const [fullName, setFullName] = useState("");
  const [phNumber, setPhNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(60);
  const [pseudoUserId, setPseudoUserId] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [enrollRewards, setEnrollRewards] = useState(false);
  const [isPhInputFocused, setIsPhInputFocused] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [verifyOtpLoading, setVerifyOtpLoading] = useState(false);

  const [pin, setPin] = useState("");
  const [pinError, setPinError] = useState("");
  const [verifyPinLoading, setVerifyPinLoading] = useState(false);

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(60);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds, minutes]);

  const handleFullName = (e) => {
    setFullName(e.target.value);
  };

  const handleRewardsCheckbox = (e) => {
    setEnrollRewards(e.target.checked);
  };

  const goToStageOne = () => {
    setStage(0);
    setError("");
  };

  const goToStageTwo = () => {
    setStage(1);
  };

  const goToStageThree = () => {
    setStage(2);
  };

  const handleOtpEntry = (otp) => {
    setOtp(otp);
  };

  const handlePinEntry = (otp) => {
    setPin(otp);
  };

  const handleVerifyPin = () => {
    setVerifyPinLoading(true);
    if (empPin === pin) {
      goToStageTwo();
      setPin("");
    } else {
      setPinError("Uh-oh! Looks like the PIN is invalid 📱");
      setVerifyPinLoading(false);
      setTimeout(() => {
        setPinError("");
      }, 5000);
      console.log("OTP Verification Unsuccessful, re-enter OTP");
    }
  };

  const handleGenerateOtp = async () => {
    if (fullName && fullName.trim() !== "" && phNumber) {
      if (phNumber.slice(0, 2) === "91") {
        if (phNumber.length !== 12) {
          //insertAlertHere
          console.log("Please enter your 10-digit mobile number");
          return false;
        }
      }

      const splitArray = fullName.split(" ");
      const firstName = splitArray[0] || "";
      const lastName = splitArray[1] || "";

      setSeconds(60);
      try {
        setOtpLoading(true);
        let apiURL = apiList.captive.getOtp;

        let regResponse = await callApi.patch(apiURL, {
          username: phNumber,
          metadata: {
            contact: phNumber,
            countryCode,
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: "",
          },
        });

        if (regResponse.status === 200 || regResponse.status === 201) {
          setPseudoUserId(regResponse.data);
          goToStageThree();
          setOtpLoading(false);
          //insertAlertHere
          console.log("Please Enter OTP");
        } else if (regResponse.status === 429) {
          setPseudoUserId(regResponse.data);
          goToStageThree();
          setOtpLoading(false);
          //insertAlertHere
          console.log(regResponse.message);
        } else {
          setOtpLoading(true);
          //insertAlertHere
          console.log(regResponse.message);
        }
      } catch (err) {
        if (err.response.data.status === 429) {
          goToStageTwo();
          setPseudoUserId(err.response.data.status.data);
        }
        //insertAlertHere
        console.log(err);
      }
    } else {
      if (!fullName || fullName.trim() === "") {
        //insertAlertHere
        console.log("Please Enter First Name");
      } else if (!phNumber) {
        //insertAlertHere
        console.log("Please Enter Mobile Number");
      }
    }
  };

  const handleResendOtp = async () => {
    setOtp("");
    const splitArray = fullName.split(" ");
    const firstName = splitArray[0] || "";
    const lastName = splitArray[1] || "";

    if (seconds < 1 && minutes < 1) {
      let apiURL = apiList.captive.getOtp;
      if (!pseudoUserId) {
        try {
          let regResponse = await callApi.patch(apiURL, {
            username: phNumber,
            metadata: {
              contact: phNumber,
              firstName: firstName.trim(),
              lastName: lastName.trim(),
              email: "",
            },
          });

          if (regResponse.status === 201) {
            //insertAlertHere
            console.log("OTP Resend Successful");
            setSeconds(60);
          } else if (regResponse.status === 429) {
            //insertAlertHere
            console.log("Previous OTP still alive, please re-use");
          } else {
            //insertAlertHere
            console.log(regResponse.message);
          }
        } catch (err) {
          //insertAlertHere
          console.log(err.response.message);
        }
      } else {
        setSeconds(60);
        //insertAlertHere
        console.log("Re-submit registration");
      }
    }
  };

  const handleVerifyOtp = async () => {
    if (otp) {
      try {
        if (phNumber) {
          setVerifyOtpLoading(true);
          const data = {
            source: "regular",
            name: pseudoUserId ? "signup" : "signin",
          };
          const userAgentData = Util.getUserAgentData(data);
          let apiURL = `${apiList.captive.local}${userAgentData}`;

          let regResponse = await callApi.patch(apiURL, {
            username: phNumber,
            password: otp,
            resource: resource,
            metadata: {
              pseudoUserId: pseudoUserId,
              otp: otp,
              skipLMS: !enrollRewards,
              referral: "",
              subscription: {
                email: {
                  promotions: true,
                  newsletter: false,
                },
              },
            },
          });
          if (regResponse.status === 200) {
            //insertAlertHere
            let userData = await getUserInfo();
            setLocalStorage("EmpData", userData);
            console.log("OTP Verification Successful");
            useUser.onLogin();
            setVerifyOtpLoading(false);
            useUser.onLogout();
            history.push("homepage");
          } else {
            //insertAlertHere
            setError("Uh-oh! Looks like the OTP is invalid 📱");
            setVerifyOtpLoading(false);
            setTimeout(() => {
              setError("");
            }, 5000);
            console.log("OTP Verification Unsuccessful, re-enter OTP");
          }
        }
      } catch (error) {
        setVerifyOtpLoading(false);
        //insertAlertHere
        console.log("Something went wrong, please try again");
      }
    } else {
      setVerifyOtpLoading(false);
      //insertAlertHere
      console.log("Enter OTP");
    }
  };

  return (
    <div className={styles.emp_signin_container}>
      <Header
        isHomepage={true}
        hideDeliveryAndLogo={true}
        hideDeliverySelection={true}
        hideStartOver={true}
      />
      <div className={styles.bg_img_top_left}>
        <Image src={BGImageTopLeft} style={{ width: "100%", height: "100%" }} />
      </div>
      <div className={styles.bg_img_bottom_right}>
        <Image
          src={BGImageBottomRight}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div className={styles.content_container}>
        <div className={styles.content_wrapper}>
          {stage === 0 ? (
            <div className={styles.stage_two_container}>
              <div className={styles.stage_one_title}>
                <Text>{pinError === "" ? "Enter your PIN" : pinError}</Text>
              </div>
              <div className={styles.stage_two_sub_title}>
                <div className={styles.stage_two_sub_title_text}>
                  <Text>{`Enter the 4 digit pin for employee identification`}</Text>
                </div>
              </div>
              <div className={styles.stage_two_otp_input}>
                <CustomOtpInput
                  containerStyle={styles.otp_container_style}
                  inputStyle={styles.otp_input_style}
                  focusStyle={styles.otp_input_focus_style}
                  value={pin}
                  onChange={handlePinEntry}
                  shouldAutoFocus={true}
                />
              </div>
              <div className={styles.verify_otp_container}>
                <ButtonWithLoading
                  style={{
                    width: isTab() ? "372px" : "744px",
                    height: isTab() ? "72px" : "144px",
                    backgroundColor:
                      pin.length === 4 ? "var(--primary)" : "#7CD1CF",
                    border: "none",
                    borderRadius: isTab() ? "103px" : "206px",
                    zIndex: "1",
                  }}
                  disabled={pin.length !== 4 || verifyPinLoading}
                  onClick={() => handleVerifyPin()}
                  isLoading={verifyPinLoading}
                >
                  <div className={styles.get_otp_btn_label}>
                    <Text>Verify</Text>
                  </div>
                </ButtonWithLoading>
              </div>
              <div className={styles.stage_one_go_back}>
                <div className={styles.go_back_text}>
                  <Text onClick={() => history.goBack()}>Go Back</Text>
                </div>
              </div>
            </div>
          ) : stage === 1 ? (
            <div className={styles.stage_one_container}>
              <div className={styles.stage_one_title}>
                <Text>
                  Please enter your
                  <br />
                  employee login credentials
                </Text>
              </div>
              <div className={styles.stage_one_input_container}>
                <div className={styles.stage_one_input}>
                  <Input
                    border={isTab() ? "1px solid #DCDCDC" : "2px solid #DCDCDC"}
                    style={{
                      borderRadius: isTab() ? "9px" : "18px",
                      paddingLeft: isTab() ? "20px" : "40px",
                      fontSize: isTab() ? "20px" : "40px",
                      width: isTab()
                        ? "calc(100% - 20px)"
                        : "calc(100% - 40px)",
                      fontFamily: "Manrope",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                    }}
                    placeholder="Full name"
                    value={fullName}
                    onChange={handleFullName}
                  />
                </div>
                <div className={styles.stage_one_input}>
                  <PhoneInput
                    onFocus={() => setIsPhInputFocused(true)}
                    onBlur={() => setIsPhInputFocused(false)}
                    country={"in"}
                    countryCodeEditable={false}
                    value={phNumber}
                    onChange={(phone, data) => {
                      setPhNumber(phone);
                      setCountryCode(data.dialCode ? data.dialCode : "");
                    }}
                    containerStyle={{
                      width: "100%",
                      height: "100%",
                      marginTop: isTab() ? "25px" : "50px",
                    }}
                    inputStyle={{
                      border: isTab()
                        ? "1px solid #DCDCDC"
                        : "2px solid #DCDCDC",
                      borderRadius: isTab() ? "9px" : "18px",
                      height: "100%",
                      paddingLeft: isTab() ? "70px" : "90px",
                      width: "100%",
                      fontSize: isTab() ? "20px" : "40px",
                      fontFamily: "Manrope",
                      fontWeight: "500",
                    }}
                    buttonStyle={{
                      backgroundColor: "#ffffff",
                      fontSize: isTab() ? "20px" : "40px",
                      fontFamily: "Manrope",
                      fontWeight: "500",
                      padding: isTab() ? "0px 10px" : "0px 20px",
                      borderTopLeftRadius: isTab() ? "9px" : "18px",
                      borderBottomLeftRadius: isTab() ? "9px" : "18px",
                      border: isPhInputFocused ? "2px solid #273135" : null,
                    }}
                    dropdownStyle={{
                      width: isTab() ? "250px" : "500px",
                      maxHeight: isTab() ? "200px" : "400px",
                    }}
                  />
                </div>
                <div className={styles.get_otp_container}>
                  <ButtonWithLoading
                    style={{
                      width: isTab() ? "335px" : "670px",
                      height: isTab() ? "72px" : "144px",
                      backgroundColor: "var(--primary)",
                      border: "none",
                      borderRadius: isTab() ? "102px" : "206px",
                      zIndex: "1",
                      opacity:
                        fullName && fullName.trim() !== "" && phNumber
                          ? "1"
                          : "0.4",
                    }}
                    onClick={() => handleGenerateOtp()}
                    disabled={otpLoading}
                    isLoading={otpLoading}
                  >
                    <div className={styles.get_otp_btn_label}>
                      <Text>Get OTP</Text>
                    </div>
                  </ButtonWithLoading>
                </div>
              </div>
              <div className={styles.stage_one_go_back}>
                <div className={styles.go_back_text}>
                  <Text onClick={() => history.goBack()}>Go Back</Text>
                </div>
              </div>
            </div>
          ) : stage === 2 ? (
            <div className={styles.stage_two_container}>
              <div className={styles.progress_bar_container}>
                <Image src={TwoOfTwo} className={styles.progress_bar_img} />
              </div>
              <div className={styles.stage_one_title}>
                <Text>{error === "" ? "Verify your OTP" : error}</Text>
              </div>
              <div className={styles.stage_two_sub_title}>
                <div className={styles.stage_two_sub_title_text}>
                  <Text>{`Enter the 4 digit code sent to`}</Text>
                </div>
                <div className={styles.stage_two_ph_no}>
                  <Text>{`+${phNumber}`}</Text>
                </div>
              </div>
              <div className={styles.stage_two_otp_input}>
                <CustomOtpInput
                  containerStyle={styles.otp_container_style}
                  inputStyle={styles.otp_input_style}
                  focusStyle={styles.otp_input_focus_style}
                  value={otp}
                  onChange={handleOtpEntry}
                  shouldAutoFocus={true}
                />
              </div>
              <div className={styles.stage_two_timer_container}>
                {seconds > 0 && (
                  <div className={styles.timer_text}>
                    <Text>
                      {`Time remaining  00:${
                        seconds > 9 ? seconds : `0${seconds}`
                      } secs`}
                    </Text>
                  </div>
                )}
              </div>
              <div className={styles.verify_otp_container}>
                <ButtonWithLoading
                  style={{
                    width: isTab() ? "372px" : "744px",
                    height: isTab() ? "72px" : "144px",
                    backgroundColor:
                      otp.length === 4 ? "var(--primary)" : "#7CD1CF",
                    border: "none",
                    borderRadius: isTab() ? "103px" : "206px",
                    zIndex: "1",
                  }}
                  disabled={otp.length !== 4 || verifyOtpLoading}
                  onClick={() => handleVerifyOtp()}
                  isLoading={verifyOtpLoading}
                >
                  <div className={styles.get_otp_btn_label}>
                    <Text>Verify</Text>
                  </div>
                </ButtonWithLoading>
              </div>
              <div className={styles.verify_otp_container}>
                <Button
                  style={{
                    backgroundColor: "#fff",
                    border: "none",
                    zIndex: "1",
                  }}
                  disabled={seconds > 1}
                  onClick={() => handleResendOtp()}
                >
                  <div className={styles.resend_otp_btn_label}>
                    <Text
                      color={seconds > 1 ? "#7CD1CF" : "var(--text-primary)"}
                    >
                      Resend OTP
                    </Text>
                  </div>
                </Button>
              </div>
              <div className={styles.stage_one_go_back}>
                <div className={styles.go_back_text}>
                  <Text onClick={() => goToStageOne()}>Go Back</Text>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default EmpSignin;
